<template>
  <div class="PopupSideBarBox">
    <div
      class="PopupSideBar"
      :class="{
        opened,
        collapsed,
      }"
      v-if="sidebar.length > 0"
      ref="PopupSideBar"
    >
      <div class="sideBar">
        <div
          :key="key"
          class="block"
          v-for="(item, key) in sidebar"
          @mouseenter="handleMouseOver('enter', key)"
          @mouseleave="handleMouseOver('leave', key)"
          :class="[item.is_hover ? 'is_hover' : '', item.id]"
          @click="handleBlockClick(item)"
        >
          <div class="icon-box">
            <i class="iconfont" :class="item.iconFontName"></i>
            <span class="name">{{ item.name }}</span>
          </div>
          <div class="sideBarBay" v-if="item.has_bay && item.is_hover && item.bay_data">
            <div class="content" v-html="item.bay_data" />
            <div class="arrow"></div>
          </div>
        </div>
      </div>
      <div class="collapse-btn"   @click="handleCollapseClick">
        <i class="iconfont icon-goto"></i>
      </div>
      <div class="collapse-btn collapsed" @click="handleCollapseClick">
        <i class="iconfont icon-goto"></i>
      </div>
    </div>
    <el-backtop :bottom="bottomHeight" :right="16" :visibility-height="400" v-if="backTop">
      <div class="goTop">
        <img src="../../assets/img/gotop.png" alt="" srcset="" />
        顶部
      </div>
    </el-backtop>
  </div>
</template>

<script>
import { SIDEBAR_ITEMS, SIDEBAR_NAMESPACE } from "../../utils/constants/constants.side-bar";
import { getLoginStatus, getServicePhone,hasBid,extractNumbersFromText } from "../../utils/common";
import { OLD_USER_CENTER_URL } from "../../utils/constants/constants";
import {restMpAuthWxCommoncode} from "../../services/layOut";

export default {
  name: "LibLayoutSideBar",
  components: {},
  props: {
    backTop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opened: true,
      collapsed: false,
      sidebar: [],
      bottomHeight: 0,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
    isPayBefore() {
      return this.$store.getters["basic/isPayBefore"];
    },
  },
  watch: {
    userInfo: {
      handler() {
        this.setSidebarBlocks();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleCollapseClick() {
      this.opened = !this.opened;
      this.collapsed = !this.collapsed;
    },
    handleMouseOver(status, index) {
      if (status === "enter") {
        this.sidebar[index].is_hover = true;
      }
      if (status === "leave") {
        this.sidebar[index].is_hover = false;
      }
    },
    handleBlockClick(item) {
      if (!item.clickAction) return;
      switch (item.id) {
        case SIDEBAR_NAMESPACE.PRESALE_CONSULT:
          window.open(this.userInfo.userId ? item.link + `?orgid=${this.userInfo.userId}` : item.link);
          break;
        case SIDEBAR_NAMESPACE.USER_CENTER:
          if (getLoginStatus()) {
            // 已登录
            window.open(OLD_USER_CENTER_URL);
          } else {
            // 未登录
            this.$store.commit("basic/updateIsShowDialogLogin", true);
            this.$store.commit("basic/updateLoginSuccessGo", { type: "open", url: OLD_USER_CENTER_URL });
          }
          break;
        default:
          window.open(item.link);
      }
    },
   async   setSidebarBlocks() {
      const sidebar = [];
      // 在线咨询显示逻辑 非免费用户
      if (this.isPayBefore) {
        sidebar.push(SIDEBAR_ITEMS.find((v) => v.id === SIDEBAR_NAMESPACE.ONLINE_CONSULT));
      }
      if (!this.isPayBefore) {
        // 售前咨询 免费用户
        sidebar.push(SIDEBAR_ITEMS.find((v) => v.id === SIDEBAR_NAMESPACE.PRESALE_CONSULT));
      }
      // 咨询热线
      let hot_line_block = SIDEBAR_ITEMS.find((v) => v.id === SIDEBAR_NAMESPACE.HOT_LINE);
      (hot_line_block.bay_data = `
            <div class="tip" >咨询电话：</div>
            <div class="phone" >${getServicePhone(this.$store.getters["basic/isPayBefore"])}</div>
            `),
        sidebar.push(hot_line_block);
      
        if(hasBid()){
       // 详情服务号
         const id =extractNumbersFromText(window.location.href);

        const datas=SIDEBAR_ITEMS.find((v) => v.id === SIDEBAR_NAMESPACE.DETAIL_SERVICE_ACCOUNT);
         const res=  await restMpAuthWxCommoncode({param:`bid_${id}`})
          let qrCode = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${res.data.ticket}`;
        datas.bay_data=`
           <img class="qrcode"  src="${qrCode}" alt="" />
            <div class="tip-bottom" >扫码关注公众号 <br/>招标商机<span>手机实时看</span></div>
            `
        
      sidebar.push(datas);
          setTimeout(() => {
            this.handleMouseOver('enter', 2)
            setTimeout(() => {
              this.handleMouseOver('leave', 2)
            }, 3000);
          }, 600);
        }
     
      // 会员中心
      sidebar.push(SIDEBAR_ITEMS.find((v) => v.id === SIDEBAR_NAMESPACE.USER_CENTER));

      this.sidebar = sidebar;

    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.PopupSideBar) {
        console.log(this.$refs.PopupSideBar.getBoundingClientRect());
        const res= this.$refs.PopupSideBar.getBoundingClientRect();
        this.bottomHeight = res.bottom-res.height-100;
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/config.scss";

.collapsed {
  animation: collapsed 0.35s ease-in 1;
  animation-fill-mode: forwards; // 让css保持在动画停止的状态
}

.opened {
  animation: opened 0.35s ease-in 1;
  animation-fill-mode: forwards; // 让css保持在动画停止的状态
}

@keyframes collapsed {
  from {
    right: 16px;
  }
  to {
    right: -$layout-side-bar-width;
  }
}

@keyframes opened {
  from {
    right: -$layout-side-bar-width;
  }
  to {
    right: 16px;
  }
}

.PopupSideBarBox {
  width: 0px;
  height: 100%;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 109;
}

.PopupSideBar {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  width: 68px;
  background: #ffffff;
  border-radius: 34px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px 0 16px;

  &.collapsed {
    .sideBar {
      z-index: 1;
    }

    .collapse-btn.collapsed {
      left: -51px;
    }
  }

  .collapse-btn.collapsed {
    position: absolute;
    top: 50%;
    left: $layout-side-bar-width;
    width: 68px;
    padding: 24px 7px;
    border-radius: 50% 0 0 50%;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    z-index: 0;
    transform: translateY(-50%);
    transition: all 0.4s;

    i {
      display: block;
      transform: rotate(180deg) translateX(-22px);
      transform-origin: left;
    }
  }

  .sideBar {
    background: #fff;
    width: 100%;
    border-radius: 28px;

    .block {
      position: relative;

      &.presale-consult {
        position: absolute;
        top: -92px;
        right: 0;
        width: 72px;
        height: 72px;
        background: url("../../assets/img/header/Customerserviceavatar.png") no-repeat;

        .icon-box {
          width: 100%;
          height: 100%;

          &:after {
            content: "1";
            border: 2px solid #fff;
            width: 20px;
            height: 20px;
            background: $theme-color;
            line-height: 20px;
            text-align: center;
            border-radius: 50%;
            position: absolute;
            left: 49px;
            top: 2px;
            color: #fff;
            font-weight: 600;
          }

          .name {
            position: absolute;
            bottom: -3px;
            left: 0;
            background: #fff;
            text-align: center;
            width: 68px;
            height: 20px;
            border-radius: 10px;
            line-height: 20px;
            color: $theme-color;
          }
        }
      }
    }

    .icon-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      color: #383838;
      line-height: 16px;
      padding: 12px 0;
      position: relative;

      .iconfont {
        font-size: 20px;
        line-height: 20px;
        margin-bottom: 8px;
        color: #333;
      }

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 20px;
        width: 32px;
        border-top: 1px solid #eeeeee;
      }

      //.icon-border {
      //  margin: 12px 0;
      //  width: 32px;
      //  border-top: 1px solid #eeeeee;
      //}
    }
  }

  .sideBarBay {
    border: 0.5px rgba(0, 0, 0, 0.1) solid;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    position: absolute;
    top: 0;
    right: 86px;
    z-index: 1;
    padding: 12px;
    color: #383838;
    background-color: white;

    .arrow {
      border-top: 0.5px rgba(0, 0, 0, 0.1) solid;
      border-right: 0.5px rgba(0, 0, 0, 0.1) solid;
      width: 10px;
      height: 10px;
      position: absolute;
      right: -5px;
      top: 20px;
      transform: rotate(45deg);
      background-color: white;
      z-index: -1;
    }

    .content {
      display: flex;
      flex-direction: column;
      margin-right: -45px;
      padding-right: 45px;

      ::v-deep .qrcode {
        width: 150px;
        height: 150px;
        object-fit: cover;
      }

      ::v-deep .tip {
        color: #383838;
        font-size: 14px;
        font-weight: 550;
        text-align: left;
        line-height: 20px;
      }
   
      ::v-deep .tip-bottom {
        color: #383838;
        font-size: 13px;
        font-weight: 550;
        text-align: left;
        line-height: 20px;
        text-align: center;
        span{
          color: $theme-color;
        }
      }
      ::v-deep .phone {
        color: $theme-color;
        font-size: 14px;
        font-weight: 550;
        width: 126px;
        text-align: center;
        height: 44px;
        background: #f9fafc;
        border-radius: 4px;
        line-height: 44px;
        margin-top: 12px;
      }
    }
  }

  .collapse-btn {
    line-height: 20px;
    padding-top: 12px;

    .iconfont {
      font-size: 20px;
      color: #c6c6c6;
    }
  }

  .is_hover {
    .icon-box {
      color: $theme-color;
      font-weight: $font-weight-Medium;

      .iconfont {
        color: $theme-color;
      }
    }
  }
}
.el-backtop {
  width: 68px;
  height: 84px;
}
.goTop {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  color: #383838;
  line-height: 16px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 20px;
    margin-bottom: 8px;
  }
}
</style>
